<div class="form-group" [formGroup]="formParent">
    <input type="url" class="form-control" [formControlName]="'string'">
</div>